<div class="appbased-tv__account-selection">
  <div class="appbased-tv__account-selection__body">
    <ds-icon class="icon-overide mb-8" name="community" [ariaHidden]="true" size="48" [colour]="'body-highlight'"></ds-icon>
    <h1 class="text-title-1 mb-8">{{'global.account-selection.header' | translate}}</h1>
    <p class="text-body">{{'global.account-selection.message' | translate}}</p>
    <div class="appbased-tv__account-selection__selections"
        [ngClass]="{ 'appbased-tv__account-selection__selections__overflow ds-scrollbar' : accounts.length > 4 }" 
    >
      <ds-radio-group [(ngModel)]="selected" 
                      (ngModelChange)="printAccountSelectionChange()"
                      [ariaLabel]="''" 
                      name="accounts-selection">
        <div class="appbased-tv__account-selection__account-buttons">
          <ds-selection *ngFor="let selection of accounts; let last = last" 
                        [ngClass]="{ 'mt-24': true, 'w-75': true, 'mb-24': last }"
                        [hasPadding]="true" 
                        [value]="selection" 
                        [checked]="selected === selection.accountNumber"
                        [checkedCopy]="selection.accountNumber">
                        {{ selection.accountNumber }}
          </ds-selection>
        </div>
      </ds-radio-group>
    </div>
    <button ds-button
            class="appbased-tv__account-selection__continue"
            [variant]="CTATypes.PRIMARY"
            [attr.aria-label]="'global.account-selection.cta.alt' | translate"
            [attr.title]="'global.account-selection.cta.alt' | translate"
            (click)="continue()"
            [disabled]="!selected"
    >
      {{'global.account-selection.cta.continue' | translate}}
    </button>
  </div>
</div>
